import { Model } from 'modules/core/lib/mobx-rest'

interface IAssignment {
  id: number
  access_id: number
}

class Assignment extends Model<IAssignment> {
  static urlRoot() {
    return '/complaints/assignments'
  }
}

export default Assignment
